/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".dropdown-toggle[_ngcontent-%COMP%]:after{display:none}@media only screen and (max-width:767px){.parent[_ngcontent-%COMP%]   .logomain[_ngcontent-%COMP%]{box-shadow:none!important;border-bottom:2px solid #efb100!important}}"];
export { styles as styles };

